import React from 'react';

const Impressum: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Impressum</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Angaben gemäß § 5 TMG</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-lg font-semibold text-gray-900 mb-2">Flugsportverein Otto Lilienthal Bad Langensalza e.V.</p>
              <p>Thamsbrücker Landstraße 28</p>
              <p>99947 Bad Langensalza</p>
              <p className="mt-4">
                <strong>Telefon:</strong> +49 3603 895 8503<br />
                <strong>E-Mail:</strong> info@flugsportverein.eu
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Vereinsregister</h2>
            <p>
              <strong>Registergericht:</strong> Amtsgericht Mühlhausen<br />
              <strong>Registernummer:</strong> VR 450009</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Vertretungsberechtigter Vorstand</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="text-lg font-medium text-gray-800 mb-2">1. Vorsitzender</h3>
                <p>Tobias Herz</p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-800 mb-2">2. Vorsitzender</h3>
                <p>⁠Lars Zimmermann</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 mt-4">
              Der Verein wird durch den Vorstand vertreten. Jedes Vorstandsmitglied ist einzelvertretungsberechtigt.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Gemeinnützigkeit</h2>
            <p>
              Der Flugsportverein Otto Lilienthal Bad Langensalza e.V. ist als gemeinnützig anerkannt und 
              verfolgt ausschließlich und unmittelbar gemeinnützige Zwecke im Sinne des Abschnitts 
              "Steuerbegünstigte Zwecke" der Abgabenordnung.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              Der Vorstand<br />
              Flugsportverein Otto Lilienthal Bad Langensalza e.V.<br />
              Thamsbrücker Landstraße 28<br />
              99947 Bad Langensalza
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Haftungsausschluss</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">Haftung für Inhalte</h3>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
              unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach 
              Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt 
              der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden 
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">Haftung für Links</h3>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die 
              verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
              Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte 
              einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige 
              Links umgehend entfernen.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">Urheberrecht</h3>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. 
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte 
              Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem 
              auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei 
              Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" className="text-primary hover:text-primary-dark underline" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="bg-primary-mist p-6 rounded-lg">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Website-Entwicklung</h2>
            <p>
              Diese Website wurde entwickelt von:<br />
              <strong>www.leanofy.de</strong>
            </p>
          </section>

          <div className="text-sm text-gray-500 mt-8 pt-4 border-t">
            <p>Stand: {new Date().toLocaleDateString('de-DE')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum; 